/** Shared by GitHub authorization and code exchange so both use the same callback. */
export function getGithubOauthRedirectUri(): string {
  return new URL('/login', window.location.origin).href
}
